export default (param) => {
  if (window.__fs_dncs_instance) {
    window.__fs_conf = window.__fs_conf || [];
    window.__fs_conf.push(['setParameterString', param]);
    window.__fs_dncs_instance.trackPage(window.location.href);
  }
};
